import { createUrlWithSourceQueryParams } from '@crehana/analytics';
import { Button } from '@crehana/compass.ui/button';
import { cn } from '@crehana/compass.ui/utils';
import Link from 'next/link';

import { COURSE_DETAIL_AMPLITUDE_PAGE_NAME } from '../../constants';
import { useAssignContentLeaderFeature } from '../../hooks/use-assign-content-leader-feature';
import { useCourseDetailTranslation } from '../../hooks/useCourseDetailTranslation';

type TLeaderAssignContentButtonProps = {
  className?: string;
  courseId: string;
  organizationSlug: string;
};

export const LeaderAssignContentButton: React.FC<
  TLeaderAssignContentButtonProps
> = ({ className, courseId, organizationSlug }) => {
  const { t } = useCourseDetailTranslation();
  const { isAssignContentLeaderEnabled, isLoadingAssignContentLeaderEnabled } =
    useAssignContentLeaderFeature();

  if (isLoadingAssignContentLeaderEnabled || !isAssignContentLeaderEnabled) {
    return null;
  }

  return (
    <Link
      href={createUrlWithSourceQueryParams({
        url: `/org/${organizationSlug}/my-team/assignment/courses/${courseId}/`,
        source: COURSE_DETAIL_AMPLITUDE_PAGE_NAME,
        sourceDetail: 'Assign Content Button',
      })}
    >
      <Button
        type="button"
        size="md"
        variant="primary"
        inverse
        className={cn('tw-w-full tw-justify-center', className)}
      >
        {t('LEADER_ASSIGN_TEAM_BUTTON')}
      </Button>
    </Link>
  );
};
